import React from 'react';
import { Modal } from '@zambezi/sdk/modal';
import { useStateContext } from '@zambezi/caballo-vivo';
var ChangesTo90DayAccessModal = function ChangesTo90DayAccessModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var state = useStateContext();
  var copy = state.getIn(['brand', 'copy']);
  return /*#__PURE__*/React.createElement(Modal, {
    className: "ob-modal js-modal",
    title: copy.get('changes-90-day-auth-access.title'),
    withBackdrop: true,
    withPadding: true,
    open: open,
    onCancel: onClose,
    renderFooter: function renderFooter(onConfirm, onCancel) {
      return /*#__PURE__*/React.createElement("div", {
        className: "zb-modal-card-foot-actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: "js-cancel-action zb-button zb-button-primary zb-modal-action",
        onClick: onCancel
      }, "Close"));
    }
  }, copy.get('changes-90-day-auth-access.details'));
};
export default ChangesTo90DayAccessModal;